module.exports = __webpack_public_path__ + "img/37.a5fd05c7.png";